import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./TeamsSkeletonList.module.css";

export function TeamsSkeletonList() {
  return (
    <div className={styles["skeleton-wrapper"]}>
      <FixaSkeleton width="100%" height="48px" />
      <FixaSkeleton width="100%" height="48px" />
      <FixaSkeleton width="100%" height="48px" />
      <FixaSkeleton width="100%" height="48px" />
      <FixaSkeleton width="100%" height="48px" />
    </div>
  );
}
